import PropTypes from 'prop-types';
import React from 'react';

import CommonTreeSelectorBase from '../../../../common/components/controls/CommonTreeSelector';
import translatePropTypes from '../../../translatePropTypes';
import withTranslations from '../../utils/Translations/withTranslations';

@withTranslations
export default class ReportCategoryTreeSelector extends React.PureComponent {
  static propTypes = {
    ...translatePropTypes,
    ...CommonTreeSelectorBase.propTypes,
    models: PropTypes.array,
  };

  static defaultProps = {
    models: [
      {
        id: 1,
        name: 'ORGANISATION',
        parentId: null,
      },
      {
        id: 2,
        name: 'PEOPLE_RECORDS',
        parentId: null,
      },
      {
        id: 3,
        name: 'STUDENTS',
        parentId: 2,
      },
      {
        id: 4,
        name: 'STUDENT RELATIONS',
        parentId: 2,
      },
      {
        id: 5,
        name: 'STAFF',
        parentId: 2,
      },
      {
        id: 6,
        name: 'OTHER ENTITIES',
        parentId: 2,
      },
      {
        id: 7,
        name: 'ALL ENTITIES',
        parentId: 2,
      },
      {
        id: 8,
        name: 'QUEST',
        parentId: null,
      },
      {
        id: 9,
        name: 'MULTISPAN',
        parentId: null,
      },
    ],
  };

  nodeSortingOptions = { iteratees: ['sequence', 'name', 'id'], order: 'asc' };

  render() {
    const { models } = this.props;
    return (
      <CommonTreeSelectorBase
        isSingleSelector
        models={models}
        plugins={{
          nodeSortingOptions: this.nodeSortingOptions,
        }}
        {...this.props}
      />
    );
  }
}
